import { CategoryState, ItemState } from '@/redux';
import {
  ItemMenuTreeTableNode,
  MAX_CATEGORY_ITEM_COUNT,
  MAX_SUBCATEGORY_ITEM_COUNT,
  MIN_CATEGORY_ITEM_COUNT,
  MIN_SUBCATEGORY_ITEM_COUNT,
} from './convertItemMenuItemsToTreeTableData';

interface ConvertArgs {
  categories: CategoryState[];
  items: ItemState[];
  mapItem: (item: ItemState) => ItemMenuTreeTableNode;
  mapItemDescription: (item: ItemState) => ItemMenuTreeTableNode;
  mapCategory: (category: CategoryState) => ItemMenuTreeTableNode;
}

export const ITEM_DESCRIPTION_PREFIX = 'item-description://';

export function convertCategoryAndItemsToTreeData(args: ConvertArgs) {
  const {
    categories,
    items,
    mapItem,
    mapCategory: _mapCategory,
    mapItemDescription,
  } = args;

  function mapCategory(
    category: CategoryState,
    rootCategory?: CategoryState,
    middleCategory?: CategoryState,
  ): ItemMenuTreeTableNode {
    const categoryChildren = category!.children
      ? category!.children.map((x) =>
          mapCategory(
            x,
            rootCategory ?? category,
            rootCategory ? middleCategory ?? category : undefined,
          ),
        )
      : [];

    const itemChildren = items!
      .filter((x) => x.categoryId === category.id)
      .map((x) => ({
        ...mapItem(x),
        children: [
          {
            ...mapItemDescription(x),
          },
        ],
      }));

    return {
      ..._mapCategory(category),
      category: rootCategory ?? category,
      subCategory1: rootCategory ? middleCategory ?? category : undefined,
      subCategory2: rootCategory && middleCategory ? category : undefined,
      max:
        rootCategory || middleCategory
          ? MAX_SUBCATEGORY_ITEM_COUNT
          : MAX_CATEGORY_ITEM_COUNT,
      min:
        rootCategory || middleCategory
          ? MIN_SUBCATEGORY_ITEM_COUNT
          : MIN_CATEGORY_ITEM_COUNT,
      children: [...itemChildren, ...categoryChildren],
    };
  }

  return categories!.map((x) => mapCategory(x));
}
